import { useEffect, useState } from "react";

export type AuthHealth = {
  environment?: string;
  auth_mode?: string;
  github_oauth?: boolean;
  google_oauth?: boolean;
  email_auth?: boolean;
  app_origin?: string | null;
};

export { parseAuthError } from "./auth-callback.ts";

/** Staging/dev skip login. Production health never reports this. */
export function isAuthBypassMode(health: AuthHealth | null | undefined): boolean {
  return health?.auth_mode === "auth_bypass";
}

/**
 * Production pcbx.ai hosts — SPA must not wait-then-skip there.
 * Staging dogfood is `dev.pcbx.ai` / `*.dev.pcbx.ai` (trailing-dot OK); those
 * return false. Apex / www / app / auth / agent stay production.
 */
export function isBrowserProductionAuthHost(hostname?: string): boolean {
  const raw =
    hostname ?? (typeof window !== "undefined" ? window.location.hostname : "");
  const host = raw.toLowerCase().replace(/\.+$/, "");
  if (host === "dev.pcbx.ai" || host.endsWith(".dev.pcbx.ai")) return false;
  return host === "pcbx.ai" || host.endsWith(".pcbx.ai");
}

export function useAuthHealth(): { health: AuthHealth; loaded: boolean } {
  const [health, setHealth] = useState<AuthHealth>({});
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    let cancelled = false;
    void fetch("/api/health", { credentials: "include" })
      .then((res) => (res.ok ? res.json() : null))
      .then((body: AuthHealth | null) => {
        if (!cancelled && body) setHealth(body);
      })
      .catch(() => {
        /* Worker down → leave health empty (fail-closed; buttons stay disabled). */
      })
      .finally(() => {
        if (!cancelled) setLoaded(true);
      });
    return () => {
      cancelled = true;
    };
  }, []);
  return { health, loaded };
}
